module.exports = __webpack_public_path__ + "static/media/tracking-page-1.ba0800a6.png";